<template>
    <div>
        <eod-autocomplete label="Rapport PDF template" item-value="id" item-text="name" :items="items" :value="item?item.templateId:null" return-object @input="updateTemplate"></eod-autocomplete>
        <v-row class="mt-2">
            <v-col cols="12" :md="option.type == 'divider'?12:6" v-for="(option, key) in options" :key="key">
                <component :ref="key" :key="key" :is="fields[option.type]" :option="option" :value="option.value" @input="val => updateOption(key, val)"></component>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: 'eod-report-template-selector',
    props:{
        value: Object,
        defaults: Object
    },
    data: () => ({
        item: null,
        options: {},
        items: [],
        fields: {
            image: () => import('./reports/fields/eod-report-field-image.vue'),
            color: () => import('./reports/fields/eod-report-field-color.vue'),
            boolean: () => import('./reports/fields/eod-report-field-boolean.vue'),
            text: () => import('./reports/fields/eod-report-field-text.vue'),
            divider: () => import('./reports/fields/eod-report-field-divider.vue'),
        }
    }),
    created(){
        this.loadData();
    },
    methods:{
        updateOptions(){
            this.item = {
                ...(this.defaults||{}),
                ...(this.value||{}),
            }

            this.options = {};
            if(this.item.templateId){
                for (let i = 0; i < this.items.length; i++) {
                    const item = this.items[i];
                    if(item.id == this.item.templateId){
                        this.options = item.options;
                        break;
                    }
                }

                if(this.item.options){
                    for (const key in this.options) {
                        const option = this.options[key];
                        if(this.item.options.hasOwnProperty(key)){
                            this.options[key].value = this.item.options[key];
                        }
                    }
                }
            }
        },
        loadData(){
            this.$eod.getProcessor('/report/templates').then(response => {
                if(response){
                    this.items = response.data;
                    if(this.items[0] && !this.value){
                        this.updateTemplate(this.items[0].id);
                    }

                    this.updateOptions();
                }
            });
        },
        updateOption(optionName, value){
            const val = this.value;

            if(!val.options){
                val.options = {};
            }

            val.options[optionName] = value;
            this.$emit('input', val);

            this.$nextTick(() => {
                this.updateOptions();
            });
        },
        updateTemplate(template){
            let val = this.value;

            if(!template){
                this.$emit('input', null);
                return;
            }

            val = {
                templateId: template.id,
                options: {}
            };

            this.$emit('input', val);

            this.$nextTick(() => {
                this.updateOptions();
            });
        },
    }
}
</script>